import { Component, OnInit } from '@angular/core';
import { PublisherStatsService } from '../../shared/services/publishers-stats.service';
import { WidgetType } from '../../../shared/domain/widget-type.model';
import { PublisherBidderAdUnitRequest } from './publisher-bidder-ad-unit-request.model';
import { Principal } from '../../../shared/auth/principal.service';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Domain } from '../../../shared/domain/domain.model';
import { PublisherRequestNewDomainDialogComponent } from '../ad-tags/publisher-request-new-domain-dialog.component';
import { DomainUtils } from '../../../shared/utils/domain-utils';
import { SortUtils } from '../../../shared/utils/sort-utils';
import { WidgetTypePreviewDialogComponent } from '../ad-tags/widget-type-preview-dialog.component';
import { Router } from '@angular/router';
import { DevicePlacementLabels } from '../../../shared/domain/device-placement.model';
import { SiteGroup } from '../../../shared/domain/client/site-group.model';
import { AdsTxtStatus } from '../../../shared/domain/adstxt-status.model';

@Component({
  selector: 'cm-products-bidder',
  templateUrl: './products-bidder.component.html',
  styleUrls: ['./products-bidder.component.scss']
})
export class ProductsBidderComponent implements OnInit {
  //when this grows remove it to specialized components
  //common
  request: PublisherBidderAdUnitRequest;
  widgetTypes: WidgetType[];

  //content
  chosenContentType;
  exampleAudioWidget: WidgetType;
  exampleEbooksWidget: WidgetType;

  //size
  availableWidgetTypesForContent: WidgetType[] = [];
  DevicePlacementLabels = DevicePlacementLabels;
  adSizeStepCompleted = false;

  //sites
  selectedDomain: Domain;
  // domainWidgetValidation: { valid: boolean, unitsRunningSameSizeWidgets: BridgeAdUnit[] };
  domainValidationMap = {};

  //prebid
  prebidVersions = ['Latest', 'Legacy'];
  siteGroups: SiteGroup[];

  constructor(private publisherStatsService: PublisherStatsService,
              private matDialog: MatDialog,
              private gss: GlobalSpinnerService,
              private sbs: SnackBarService,
              private router: Router,
              private principal: Principal) {
  }

  ngOnInit(): void {
    this.resetStepper();

    this.publisherStatsService.listWidgetTypes().subscribe(next => {
      this.widgetTypes = next;
      DomainUtils.setWidgetTypesDisplayName(this.widgetTypes);
      DomainUtils.setWidgetTypesSize(this.widgetTypes);
      DomainUtils.setWidgetTypeDevicePlacements(this.widgetTypes);
      this.onContentTypeChange(this.chosenContentType);

      this.exampleAudioWidget = this.widgetTypes.find(w => w.content === 'audio' && w._size === '300x250');
      this.exampleEbooksWidget = this.widgetTypes.find(w => w.content === 'ebooks' && w._size === '300x250');
    });

    this.publisherStatsService.productsSummaryApprovedDomains(this.principal.publisher.id).subscribe(domains => {
      this.siteGroups = [
        <SiteGroup>{
          name: 'Invalid ads.txt records',
          disabled: true,
          sites: domains.filter(d => d.adstxtStatus !== AdsTxtStatus.VALID)
        },
        <SiteGroup>{
          name: 'Valid ads.txt records',
          sites: domains.filter(d => d.adstxtStatus === AdsTxtStatus.VALID)
        }
      ];
    });

  }

  onDomainSelected() {
    this.widgetTypes.forEach(w => w._selected = false);
    this.domainValidationMap = {};
    this.setAdSizeStepCompleted();
  }

  onContentTypeChange(contentType) {
    this.availableWidgetTypesForContent = this.widgetTypes
      .filter(w => w.content === contentType)
      .sort(SortUtils.propertyComparatorNumber('_size'));
  }

  addNewDomain() {
    this.matDialog.open(PublisherRequestNewDomainDialogComponent)
      .afterClosed().subscribe(result => {
      if (result) {
        this.request.newDomains.push(result);
      }
    });
  }

  removeExistingDomain(domain) {
    this.request._domains.splice(this.request._domains.indexOf(domain), 1);
  }

  onWidgetSelected(w: WidgetType, checked: boolean) {
    // if (checked) {
    // this.publisherStatsService.validateWidgetTypeForDomains(w.id, this.request._domains.map(d => d.id)).subscribe(valResult => {
    //   this.domainValidationMap[w.id] = valResult;
    //   this.setAdSizeStepCompleted();
    // });
    // } else {
    //   delete this.domainValidationMap[w.id];
    // }
    this.setAdSizeStepCompleted();
    if (w._devicePlacements && w._devicePlacements.length) {
      w._selectedDevicePlacement = w._devicePlacements[0];
    }
  }

  setAdSizeStepCompleted() {
    const atLeastOneSelected = this.availableWidgetTypesForContent.some(w => w._selected);
    // const allSelectedValid = this.availableWidgetTypesForContent.filter(w => w._selected).every(w => !this.domainValidationMap[w.id] || this.domainValidationMap[w.id].length === 0);
    this.adSizeStepCompleted = atLeastOneSelected;
  }

  submit() {
    this.request.widgetTypeIds = this.availableWidgetTypesForContent.filter(w => w._selected)
      .reduce((prev, curr) => {
        prev[curr.id] = curr._selectedDevicePlacement;
        return prev;
      }, {});

    if (!this.principal.publisher.tipaltiPayable) {
      this.sbs.error('Tipalti information is missing');
      return;
    }

    this.request.domainIds = this.request._domains.map(d => d.id);
    this.gss.showLoader();
    this.publisherStatsService.productsRequestBidderUnit(this.request).subscribe(next => {
        this.gss.hideLoader();
        this.sbs.success('Bidder request submitted successfully');
        this.router.navigate(['/products/bidder/success']);
      },
      () => {
        this.gss.hideLoader();
        this.sbs.error('Error occurred while creating bidder request, please contact our support');
      });
  }

  getSelectedWidgetTypesString() {
    return this.availableWidgetTypesForContent.filter(w => w._selected).map(t => t._size).join(', ');
  }

  public openPreviewModal(widgetType: WidgetType) {
    this.matDialog.open(WidgetTypePreviewDialogComponent, <MatDialogConfig>{
      data: {
        widgetType: widgetType
      },
      panelClass: 'width-auto',
      width: `${widgetType.width + 200}px`
    });
  }

  resetStepper() {
    this.request = new PublisherBidderAdUnitRequest();
    this.request.publisherId = this.principal.publisher.id;
    this.chosenContentType = 'audio';
    this.request.prebidVersion = this.prebidVersions[0];
  }

  onClickSelectAllDomains(event) {
    if (event.checked) {
      this.request._domains = this.siteGroups[1].sites.filter(item => item);
    } else {
      this.request._domains = [];
    }
    this.onDomainSelected();
  }

}
